import { toast } from 'react-toastify';

export function allObjectPropertyTrue(obj) {
    // return Object.keys(obj).every((k) => !obj[k])
    for (let prop in obj) if (!obj[prop]) return false;
    return true;
}

// Trim all properties of an object
export const trimObjProperties = (obj) => {
    let trimmedObj = {};
    Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'string') {
            trimmedObj[key] = obj[key].trim();
        } else {
            trimmedObj[key] = obj[key];
        }
    });

    return trimmedObj;
};

/**
 * Removes properties with null, undefined, or empty string values.
 * Keeps other falsy values like 0 and false.
 */
export function filterObjectFalsyValues(sourceObject) {
  if (!sourceObject || typeof sourceObject !== 'object') {
    return {};
  }

  const sanitizedObject = {};

  for (const [key, value] of Object.entries(sourceObject)) {
    const isValueValid =
      value !== null &&
      value !== undefined &&
      value !== '';

    if (isValueValid) {
      sanitizedObject[key] = value;
    }
  }

  return sanitizedObject;
}

export function isObejctIsEmpty(obj) {
    return Object.keys(obj).length === 0;
}

// Encode file to Base64
export const toBase64 = async (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => resolve(fileReader.result.split(',')[1]);
        fileReader.onerror = (error) => reject(error);
    });
};

export const getTrimmedObject = (obj) => {
    if (obj && typeof obj === 'object') {
        Object.keys(obj).map((key) => {
            if (typeof obj[key] === 'object') {
                getTrimmedObject(obj[key]);
            } else if (typeof obj[key] === 'string') {
                obj[key] = obj[key].trim();
            }
        });
    }
    return obj;
};

/**
 * Returns the comma separated amount value of
 * the received number input.
 * Example:
 * input: 123456 => output: 1,23,456
 * @param  {number} numb
 * @return {string}
 */
export const numberWithCommas = (numb) => {
    try {
        if (numb === 0) {
            return `₹0`;
        }
        if (isNaN(numb)) {
            return '-';
        }
        const numberFormatter = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
            maximumSignificantDigits: 21,
        });
        return numberFormatter.format(numb);
    } catch (err) {
        console.error(err);
        return numb;
    }
};

// Example:1st
// input: 123456 => output: 12L
export const compactNumber = (numb) => {
    const number = parseFloat(numb);
    return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2,
        notation: 'compact',
        compactDisplay: 'short',
    }).format(number);
};

// Example:
// input: 1 => output: 1st
// input: 2 => output: 2nd
// input: 3 => output: 3rd
export const ordinalSuffixOf = (i) => {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + 'st';
    }
    if (j == 2 && k != 12) {
        return i + 'nd';
    }
    if (j == 3 && k != 13) {
        return i + 'rd';
    }
    return i + 'th';
};

export const isSuccessStatus = (responseObj) => {
    if (!(responseObj.status_code >= 200 && responseObj.status_code < 400)) {
        return false;
    }
    return true;
};

export const showErrorToast = (message) => {
    if (!message) {
        return toast.error('Oops something went wrong!!');
    }
    return toast.error(message);
};

// Open Link in new Tab
export const openLinkInNewTab = (url) => {
    let a = document.createElement('a');
    a.target = '_blank';
    a.href = url;
    a.click();
    setTimeout(function () {
        a.remove();
    }, 200);
};

// Copy to Clipboard
export async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }
}

export function fileDownload(data, filename, mime, bom) {
    var blobData = typeof bom !== 'undefined' ? [bom, data] : [data];
    var blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    } else {
        var blobURL =
            window.URL && window.URL.createObjectURL
                ? window.URL.createObjectURL(blob)
                : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function () {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200);
    }
}

export function disableFormikField(url, err) {
    if (url?.length > 0 && !err) return false;
    else return true;
}

export function dateFormatter(dateObj) {
    const dateToFormat = new Date(dateObj);

    const date = dateToFormat.getDate().toString().padStart(2, '0');
    const month = (dateToFormat.getMonth() + 1).toString().padStart(2, '0'); 
    const year = dateToFormat.getFullYear(); 

    return `${date}-${month}-${year}`;
}

export function stringDateFormatter(dateString) {
    if (!dateString) return null; 
    
    const [day, month, year] = dateString.split('-').map(Number); 
    
    return new Date(year, month - 1, day); 
}


export const ScrollView = (elem, offset) => {
    const refTop = elem?.getBoundingClientRect().top;
    const offsetPosition = refTop + window.pageYOffset - offset;
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    });
};

/**
 * Creates an anchor element `<a></a>` with
 * the base64 pdf source and a filename with the
 * HTML5 `download` attribute then clicks on it.
 * @param  {string} pdf
 * @return {void}
 */
export function downloadPDF(base64, filename) {
    const linkSource = `data:application/pdf;base64,${base64}`;
    const downloadLink = document.createElement('a');
    const fileName = `${filename}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

/**
 * Creates query params string
 * Example:
 * input: {var1: "value",var2: "value2",arr: "foo",};
 * output: "var1=value&var2=value2&arr=foo"
 * @param  {obj} paramObj
 * @return {string}
 */
 export function getQueryParamsString(paramsObj=null) {
    const filteredObject = filterObjectFalsyValues(paramsObj);
    if (isObejctIsEmpty(filteredObject)) return '';
    const params = new URLSearchParams(filteredObject || {});
    const paramString = params?.toString();
    return paramString;
}

export function generateRandomMobileNumber() {
    const DIGITS = 9;
    const random_number = Math.floor(100000000 + Math.random() * (DIGITS * 100000000));
    return `$$9${random_number}$$`;
}

export function generateRandomStudentId(LENGTH=10) {
    const p = "ABCDEFGHIJKLMNOPQRSTUVWYZabcdefghijklmnopqrstuvwyz0123456789";
    const str = [...Array(LENGTH)].reduce(a=>a+p[~~(Math.random()*p.length)],'');
    return `$$${str}$$`;
}

export function hasDollarInString (text) {
    if (!text) return false;
    return text.toString().indexOf("$$") === 0 && text.toString().lastIndexOf("$$") === (text.length - 2);
}

// Detect link in text
export function detectLinkInText(text, appendParams=null) {
    if(!text) return null;

    // var derText = "This is some text with [a link](https://duckduckgo.com) \n\ and break line";
    // //replace the linebreaks with <br>
    // derText = derText.replace(/(?:\r\n|\r|\n)/g, '<br>');
    // //check for links [text](url)
    let queryParams='';
    if (appendParams && Object.keys(appendParams).length !== 0) {
        queryParams='?';
        queryParams += new URLSearchParams(appendParams).toString()
    }
    let derText = text;
    derText = derText.replace(/(?:\r\n|\r|\n)/g, '<br>');
    let elements = derText.match(/\[.*?\)/g);
    if( elements != null && elements.length > 0){
        elements?.map(el => {
            let txt = el.match(/\[(.*?)\]/)[1];//get only the txt
            let url = el.match(/\((.*?)\)/)[1];//get only the link
            derText = derText.replace(el,'<a href="'+url+queryParams+'" rel="noopener noreferrer nofollow" target="_blank">'+txt+'</a>')
        })
    }
    return derText;
}

export const roundDecimalValue = (num) => {
    if(isNaN(num)){
        console.error('Please enter a valid number');
        return num;
    }
    return Math.round(num * 100) / 100
}

// refactor with numberWithCommas
export const rupeeNumberFormatter = (numb) => {
    try {
        if (numb === 0) {
            return 'Rs. 0';
        }
        if (isNaN(numb) || numb === null) {
            return '-';
        }
        const numberFormatter = new Intl.NumberFormat('en-IN', {
            maximumFractionDigits: 0,
            maximumSignificantDigits: 21,
        }).format(numb);
        return `Rs. ${numberFormatter}`;
    } catch (err) {
        console.error(err);
        return numb;
    }
};

// to generate mixpanel random distinct id
export const generateSecureUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] &
                (15 >> (c / 4)))
        ).toString(16),
    );
}

export const isValidMobileNumber = (mobileNumber) => {
    const mobileNumberRegex = /^[6-9]\d{9}$/;
    return mobileNumberRegex.test(mobileNumber);
}

// a function to retry loading a chunk to avoid chunk load error for out of date code
export const lazyRetry = (componentImport, name) => new Promise((resolve, reject) => {
    // check if the window has already been refreshed
    const hasRefreshed = JSON.parse(
        window.sessionStorage.getItem(`retry-${name}-refreshed`) || 'false'
    );
    // try to import the component
    componentImport().then((component) => {
        window.sessionStorage.setItem(`retry-${name}-refreshed`, 'false'); // success so reset the refresh
        resolve(component);
    }).catch((error) => {
        if (!hasRefreshed) { // not been refreshed yet
            window.sessionStorage.setItem(`retry-${name}-refreshed`, 'true'); // we are now going to refresh
            return window.location.reload(); // refresh the page
        }
        reject(error);
    });
});